import { createStrictContext } from '@apeiron/temp'
import { Dispatch, FC, ReactChild, SetStateAction, useState } from 'react'

const [ContextProvider, useOrbitalTrackRentalSettingContext] =
  createStrictContext<ContextType>('OrbitalTrackRentalSetting')

export { useOrbitalTrackRentalSettingContext }

export const OrbitalTrackRentalSettingProvider: FC<Props> = props => {
  const { children } = props

  const [open, setOpen] = useState<boolean>(false)

  return <ContextProvider value={{ open, setOpen }}>{children}</ContextProvider>
}

type ContextType = {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
}

export type Props = {
  children: ReactChild | ReactChild[]
}
